import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Returns null when env vars are missing so the app degrades gracefully
// to localStorage-only mode rather than crashing.
export const supabase = url && key ? createClient(url, key) : null;
